import { U } from "../lib/U.js";
import Emitter from "./Emitter.js";
let _private = new WeakMap();
export default class Dispatcher extends Emitter {
  constructor(...args) {
    super();
    let self = this;
    _private.set(this, {
      args: args,
      events: {}
    });
    if (args.length > 0) {
      args.forEach(o => this.addEvent(o.event, o.callback));
    }
    this.dispatch = function(e) {
      let target = e.target;
      let currentTarget = e.currentTarget;
      let event;
      let events = _private.get(self).events;
      if (target && target.getAttribute && target.dataset.action) {
        event = target.dataset.action;
      } else if (
        currentTarget &&
        currentTarget.getAttribute &&
        currentTarget.dataset.action
      ) {
        event = currentTarget.dataset.action;
        target = currentTarget;
      } else {
        event = e.type;
      }
      if (events[event] && events.hasOwnProperty(event)) {
        _private.get(self).events[event].forEach(listener => {
          try {
            listener.apply(this, [e, target]);
            if (listener.once) {
              this.removeListener(event, listener);
            }
          } catch (err) {
            if (events.error && events.hasOwnProperty("error")) {
              self.dispatch({
                type: "error",
                err: err,
                target: this
              });
            } else {
              console.log(err);
            }
          }
        });
        return true;
      } else {
        return false;
      }
    };
  }
  once(event, listener) {
    listener.once = true;
    return this.addEvent(event, listener);
  }
  removeListener(event, listener) {
    let events = _private.get(this).events;
    if (typeof events[event] !== "undefined") {
      events[event] = events[event].filter(fn => fn !== listener);
    }
    return this;
  }
  listeners(event) {
    let events = _private.get(this).events;
    let listeners = null;
    if (typeof events[event] !== "undefined") {
      listeners = U.copyArr(events[event]);
    }
    return listeners;
  }
  addEvent(event, listener) {
    let events = _private.get(this).events;
    if (typeof listener !== "function") {
      throw new TypeError(listener + " is not a function");
    }
    if (typeof events[event] === "undefined") {
      events[event] = [listener];
    } else if (events[event].every(fn => fn !== listener)) {
      events[event].push(listener);
    }
    return this;
  }
  removeEvent(type) {
    let events = _private.get(this).events;
    delete events[type];
    return this;
  }
}
